import React, { useState, useEffect, useCallback } from 'react';
import { Divider, Transfer } from 'antd';
import { useSelector } from 'react-redux';
import { debounce } from 'lodash';


const PortfolioTransfer = ({ selectedIds = [], onSelectionChange }) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [filter, setFilter] = useState({ left: '', right: '' });
  const portfolios = useSelector(state => state.portfolios.items);

  useEffect(() => {
    setTargetKeys(selectedIds);
  }, [selectedIds, portfolios]);

  const onChange = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys);
    onSelectionChange(
      portfolios.filter(portfolio => nextTargetKeys.includes(portfolio.id))
        .map(x => ({ id: x.id, type: x.type }))
    );
  };

  // Debounced version of the search function
  const debouncedSearch = useCallback(debounce((dir, value) => {
    setFilter(prev => ({ ...prev, [dir]: value }));
  }, 300), []); // Adjust the debounce timing as needed

  const onSearch = (dir, value) => {
    debouncedSearch(dir, value);
  };

  const filteredData = portfolios.filter(portfolio => {
    return (!filter.left || portfolio.name.toLowerCase().includes(filter.left.toLowerCase())) &&
           (!targetKeys.includes(portfolio.id)) ||
           (!filter.right || portfolio.name.toLowerCase().includes(filter.right.toLowerCase())) &&
           (targetKeys.includes(portfolio.id));
  });

  const data = filteredData.map(portfolio => ({
    key: portfolio.id,
    title: portfolio.name,
    description: portfolio.type,
  }));

  return (
    <div>
      <p>Select available portfolios on the left side and move them to the right side to mark them as selected. You can search portfolios by name in both lists.</p>
      <Divider/>
      <Transfer
        dataSource={data}
        titles={['Available', 'Selected']}
        targetKeys={targetKeys}
        onChange={onChange}
        render={item => item.title}
        listStyle={{
          width: 350, // Increased width for better usability
          height: 400, // Increased height to accommodate more items
        }}
        showSearch
        filterOption={(inputValue, option) =>
          option.title.toLowerCase().includes(inputValue.toLowerCase())
        }
        onSearch={onSearch}
        searchPlaceholder="Search portfolios"
      />
    </div>
  );
};

export default PortfolioTransfer;
